/* Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial */
import {guestOrigin} from "./joinSession";
import {guestRoomLink} from "./guestRoomLink";
export function staffRoomTarget(relative:string,roomId:string):string {
 // Join creates its first-party challenge before the cabinet account check.
 // No iframe storage or prior room membership is needed for this navigation.
 const target=new URL(relative,guestOrigin());
 if(target.origin!==guestOrigin())throw Error("Unexpected room destination");
 target.searchParams.delete("theme");target.searchParams.delete("lang");
 const clean=new URL(guestRoomLink(target),guestOrigin());
 const hashIndex=clean.hash.indexOf('?'),params=new URLSearchParams(clean.hash.slice(hashIndex+1));
 params.set("roomId",roomId);clean.hash=clean.hash.slice(0,hashIndex)+"?"+params.toString();
 return clean.href;
}
